import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { QrCode } from 'modules/QrCode/QrCode'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class QrHeader extends Model {
  static override entity = 'qr_headers'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare header: string | null
  @Attr(null) declare code_count: number

  @HasMany(() => QrCode, 'qr_code') declare qrCodes: QrCode[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
